import { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TablePagination,
} from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const mockCompanies = ['Company A', 'Company B', 'Company C'];
const mockJobs = [
    'Job-101 (Software Engineer)',
    'Job-102 (Product Manager)',
    'Job-103 (Designer)',
];
const mockStages = ['Applied', 'Screening', 'Interview', 'Offered', 'Hired'];

const CandidateTransfer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [source, setSource] = useState({ company: '', jobId: '', stage: '' });
    const [destination, setDestination] = useState({
        company: '',
        jobId: '',
        stage: '',
    });
    const [transferHistory, setTransferHistory] = useState([]);

    // Pagination states
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleTransfer = () => {
        if (
            source.company &&
            source.jobId &&
            destination.company &&
            destination.jobId
        ) {
            const newTransfer = {
                id: Date.now(),
                date: new Date().toLocaleString(),
                fromCompany: source.company,
                fromJob: source.jobId,
                fromStage: source.stage,
                toCompany: destination.company,
                toJob: destination.jobId,
                toStage: destination.stage,
            };
            setTransferHistory([newTransfer, ...transferHistory]);
            setDestination({ company: '', jobId: '', stage: '' });
            setIsModalOpen(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box sx={{ p: 3 }}>
            <ul>
                <li>all field must required in the Transfer Candidate modal</li>
                <li>Give a alert message before transfer and on that alert show the source and destination proper message - from-to</li>
                <li>run a progress bar untill transfer is finished. And give a proper message when transfer is completed. new transfer button will be disabled untill transfer is completed.</li>
                <li>clone from one company job to another company job not move</li>
                <li>clone candidate without ai ranking, in the destination company ai ranking will be run again. based on the destination job</li>
                <li>skip the clone - if a candidate already completed ai interview, assessment or psycology test. Only skip the clone of that candidate, don't stop the whole transfer process.</li>
                <li>remove the old past month data. a cron job could be run once a month only. not every day</li>
            </ul>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Box>
                    <Typography variant="h4" gutterBottom>
                        Candidate Transfer
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Transfer candidates from one company job to another.
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setIsModalOpen(true)}
                    startIcon={<SwapHorizIcon />}
                >
                    New Transfer
                </Button>
            </Box>

            {/* Transfer Modal */}
            <Dialog
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Transfer Candidate</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={4} alignItems="center" sx={{ mt: 0 }}>
                        {/* Source Section */}
                        <Grid item xs={12} md={5} pt={'0 !important'}>
                            <Typography variant="h6" gutterBottom color="primary">
                                Source (From)
                            </Typography>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Company Name</InputLabel>
                                <Select
                                    value={source.company}
                                    label="Company Name"
                                    onChange={(e) =>
                                        setSource({ ...source, company: e.target.value })
                                    }
                                >
                                    {mockCompanies.map((c) => (
                                        <MenuItem key={c} value={c}>
                                            {c}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Job ID</InputLabel>
                                <Select
                                    value={source.jobId}
                                    label="Job ID"
                                    onChange={(e) =>
                                        setSource({ ...source, jobId: e.target.value })
                                    }
                                >
                                    {mockJobs.map((j) => (
                                        <MenuItem key={j} value={j}>
                                            {j}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Stage</InputLabel>
                                <Select
                                    value={source.stage}
                                    label="Stage"
                                    onChange={(e) =>
                                        setSource({ ...source, stage: e.target.value })
                                    }
                                >
                                    {mockStages.map((s) => (
                                        <MenuItem key={s} value={s}>
                                            {s}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Icon Section */}
                        <Grid
                            item
                            pt={0}
                            xs={12}
                            md={2}
                            sx={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <SwapHorizIcon
                                color="action"
                                sx={{ fontSize: 48, display: { xs: 'none', md: 'block' } }}
                            />
                            <Divider
                                sx={{ display: { xs: 'block', md: 'none' }, my: 2, width: '100%' }}
                            />
                        </Grid>

                        {/* Destination Section */}
                        <Grid item xs={12} md={5} pt={'0 !important'}>
                            <Typography variant="h6" gutterBottom color="secondary">
                                Destination (To)
                            </Typography>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Company Name</InputLabel>
                                <Select
                                    value={destination.company}
                                    label="Company Name"
                                    onChange={(e) =>
                                        setDestination({ ...destination, company: e.target.value })
                                    }
                                >
                                    {mockCompanies.map((c) => (
                                        <MenuItem key={c} value={c}>
                                            {c}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Job ID</InputLabel>
                                <Select
                                    value={destination.jobId}
                                    label="Job ID"
                                    onChange={(e) =>
                                        setDestination({ ...destination, jobId: e.target.value })
                                    }
                                >
                                    {mockJobs.map((j) => (
                                        <MenuItem key={j} value={j}>
                                            {j}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Stage</InputLabel>
                                <Select
                                    value={destination.stage}
                                    label="Stage"
                                    onChange={(e) =>
                                        setDestination({ ...destination, stage: e.target.value })
                                    }
                                >
                                    {mockStages.map((s) => (
                                        <MenuItem key={s} value={s}>
                                            {s}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleTransfer}
                        disabled={
                            !source.company ||
                            !source.jobId ||
                            !destination.company ||
                            !destination.jobId
                        }
                    >
                        Transfer Candidate
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Transfer History */}
            <Typography variant="h5" gutterBottom sx={{ mt: 2 }}>
                Transfer History
            </Typography>
            <Paper sx={{ boxShadow: 2, width: '100%', mb: 2 }}>
                <TableContainer>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead sx={{ backgroundColor: 'background.default' }}>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>From Company</TableCell>
                                <TableCell>From Job</TableCell>
                                <TableCell>From Stage</TableCell>
                                <TableCell>To Company</TableCell>
                                <TableCell>To Job</TableCell>
                                <TableCell>To Stage</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transferHistory.length === 0 ? (
                                <TableRow>
                                    <TableCell
                                        colSpan={7}
                                        align="center"
                                        sx={{ py: 3, color: 'text.secondary' }}
                                    >
                                        No transfer history yet.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                transferHistory
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => (
                                        <TableRow key={row.id} hover>
                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.fromCompany}</TableCell>
                                            <TableCell>{row.fromJob}</TableCell>
                                            <TableCell>{row.fromStage}</TableCell>
                                            <TableCell>{row.toCompany}</TableCell>
                                            <TableCell>{row.toJob}</TableCell>
                                            <TableCell>{row.toStage}</TableCell>
                                        </TableRow>
                                    ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={transferHistory.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
};

export default CandidateTransfer;
